const styles = {
  button: {
    marginLeft: '16px'
  }
}

export default styles
